module.exports = __webpack_public_path__ + "static/media/realtor-2.c11e84dc.jpeg";